<template>
    <e-field grouped position="is-right" expanded>
        <e-input
            :model-value="modelValue"
            placeholder="Search..."
            type="search"
            icon="search"
            expanded
            @update:modelValue="searching"
            @keydown.enter.prevent
        />
    </e-field>
</template>

<script>
export default {
    name: 'ModalSearch',

    emits: ['update:modelValue'],

    props: {
        modelValue: {
            type: String,
            required: false,
            default: '',
        },
    },

    methods: {
        searching(payload) {
            let value = '';

            if (typeof payload === 'string') {
                value = payload;
            } else if (payload?.target && typeof payload.target.value === 'string') {
                value = payload.target.value;
            }

            this.$emit('update:modelValue', value);
        },
    },
};
</script>
